export const PlusIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 15C28 7.82292 22.1771 2 15 2C7.82292 2 2 7.82292 2 15C2 22.1771 7.82292 28 15 28C22.1771 28 28 22.1771 28 15Z"
        stroke="#26B66E"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M20.4737 15.0001H9.52637M15.0001 9.52637V20.4737V9.52637Z"
        stroke="#26B66E"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
